<div
  [ngClass]="[customClass, 'inline-message-container--' + variant, 'inline-message-container--' + contentAligment]"
  class="inline-message-container"
>
  <div class="inline-message-container__content">
    <mat-icon
      [svgIcon]="customIconName || iconNameMap[variant]"
      class="inline-message-container__content__icon"
    ></mat-icon>

    <div class="inline-message-container__content__message">
      <span *ngIf="!!title" class="inline-message-container__content__message__title">{{ title }}</span>
      <p *ngIf="!!message" class="inline-message-container__content__message__text">{{ message }}</p>
    </div>
  </div>
</div>
